<!-- Sub header for report templates -->
<app-subheader-main></app-subheader-main>

<div class="base-content-wrapper">    
    <app-message-dialog></app-message-dialog>
    <div class="left-panel-wrapper" *ngIf="showLeftPanel">     
        <app-mainleftpanelview (leftPanelToggle)="onLeftPanelToggle($event)"></app-mainleftpanelview>     
    </div>
    <div class="main-content-wrapper" [ngClass]="isLeftPanelVisible? 'left-panel-expanded' : ''">
        <router-outlet></router-outlet>
    </div>
</div> 
